import { z } from "zod";
import { VALIDATION_MESSAGES_CARD } from "constants/validations";

// Phone Type Schema
export const phoneTypeSchema = z.enum(["Home", "Mobile", "Business"], {
    errorMap: () => ({ message: VALIDATION_MESSAGES_CARD.SELECT_OPTION }),
});

export const optionalPhoneTypeSchema = z.enum(["Home", "Mobile", "Business"]).optional();
